<template>
  <div>
    <BaseTitle :title="$t('content.attendance_title')" :yearPeriode="titleData" />
    <v-card v-show="hideChart" class="mb-7">
      <div class="pa-5">
        <h3 class="app-section-title">{{ $t('content.attendance_chart') }}</h3>
        <div class="d-flex align-center justify-center">
          <chart type="donut" width="400" :options="chartOptions" :series="series" />
        </div>
      </div>
    </v-card>

    <v-card class="mb-7">
      <div class="pa-5">
        <h3 class="app-section-title">{{ $t('filter') }}</h3>
        <v-row>
          <v-col cols="12" md="6">
            <v-menu
              ref="menu"
              v-model="showCalendar"
              :close-on-content-click="false"
              :return-value.sync="filter.attendanceDate"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="filter.attendanceDate"
                  :label="$t('form.date')"
                  append-icon="mdi-event"
                  readonly
                  clearable
                  v-bind="attrs"
                  v-on="on"
                >
                  <template #append>
                    <svg-icon icon="calendar" class="primary--text mr-3" />
                  </template>
                </v-text-field>
              </template>
              <v-date-picker v-model="filter.attendanceDate" scrollable>
                <v-spacer />
                <v-btn text color="primary" @click="showCalendar = false">{{ $t('cancel') }}</v-btn>
                <v-btn text color="primary" @click="$refs.menu.save(filter.attendanceDate)">{{ $t('ok') }}</v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="6">
            <v-select v-model="filter.attendanceTypeId" :items="itemTypes" clearable :label="$t('form.attendance')">
              <template #item="{item}">{{ $t(item.text) }}</template>
              <template #selection="{item}">{{ $t(item.text) }}</template>
            </v-select>
          </v-col>
        </v-row>
      </div>
    </v-card>
    <v-card>
      <div>
        <div class="pa-5 d-flex justiy-space-between align-items section-header active">
          <div class="student-title">{{ $t('content.attendance_title') }}</div>
        </div>
        <div v-for="item in listData" :key="item.attendanceId" class="border-item">
          <v-row class="border-item">
            <v-col md="1" align="center">
              <div class="mt-5 ml-5">
                <svg-icon icon="desktop" width="30" height="30" class="primary--text" />
                <v-divider vertical></v-divider>
              </div>
            </v-col>
            <v-col md="11" class="mt-3">
              <div class="d-block">
                <h3 class="d-inline">
                  <span class="header-content">{{ $t('table.session') }} : {{ item.sessionName }} </span>
                </h3>
              </div>
              <div class="d-block">
                <div>
                  <span class="body-content">
                    <span class="mr-3">
                      {{ $t('table.date') }}:
                      <strong>{{ item.attendanceDate }}</strong>
                    </span>
                    |
                    <span class="mr-3">
                      {{ $t('table.attendance') }}:

                      <strong :style="{ color: colors[item.attendanceTypeId] }">{{ $t(itemTypes[item.attendanceTypeId - 1].text) }}</strong>
                      <!-- <strong>{{ item.attendanceDate }}</strong> -->
                    </span>
                  </span>
                </div>
              </div>
              <div class="d-flex"></div>
            </v-col>
          </v-row>
        </div>
        <NoData v-if="!listData.length" />
        <!-- <v-data-table
          :headers="tableHeader"
          :items="items"
          :loading="table.loading"
          :server-items-length="items.length"
          :options.sync="table.options"
          hide-default-footer
          class="table-custom"
        >
          <template v-slot:top>
            <table-header @fetch="getData" />
          </template>
          <template v-slot:item.attendanceTypeId="{ item }">
            <strong :style="{ color: colors[item.attendanceTypeId] }">{{ $t(itemTypes[item.attendanceTypeId - 1].text) }}</strong>
          </template>
          <template v-slot:no-data><NoData /></template>
        </v-data-table>
        <table-footer @fetch="getData" /> -->
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';
// import TableHeader from '@/components/table/TableHeader';
// import TableFooter from '@/components/table/TableFooter';
import NoData from '@/components/table/NoData';
import Chart from 'vue-apexcharts';

export default {
  name: 'AttendanceIndex',
  components: {
    BaseTitle,
    // TableHeader,
    // TableFooter,
    Chart,
    NoData
  },
  computed: {
    ...mapGetters({
      items: 'Attendance/items',
      itemTypes: 'Attendance/itemTypes',
      student: 'Auth/student',
      isAuthenticated: 'Auth/isAuthenticated',
      user: 'Auth/user',
      nameCourse: 'CourseList/nameCourse'
    }),
    tableHeader() {
      return [
        { text: this.$t('table.session'), value: 'sessionName' },
        { text: this.$t('table.date'), value: 'attendanceDate' },
        { text: this.$t('table.attendance'), value: 'attendanceTypeId' }
      ];
    }
  },
  data: () => {
    return {
      titleData: '',
      dataClass: '',
      showCalendar: false,
      colors: {
        1: '#0177FB',
        2: '#FF6370',
        3: '#40DCA7',
        4: '#FF9743',
        5: '#C7D451'
      },
      filter: {
        attendanceDate: null,
        attendanceTypeId: null
      },
      table: {
        loading: false,
        options: {}
      },
      hideChart: true,
      series: [],
      listData: [],
      searchData: '',
      chartOptions: {
        labels: [],
        colors: [],
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                value: {
                  fontSize: '50px',
                  fontWeight: 800,
                  show: true,
                  offsetY: 20
                },
                total: {
                  show: true,
                  showAlways: true,
                  label: '',
                  formatter: function(w) {
                    function getKeyByValue(object, value) {
                      return Object.keys(object).find(key => object[key] === value);
                    }
                    if (getKeyByValue(w.globals.labels, 'Unexcuse Leave')) {
                      var key = getKeyByValue(w.globals.labels, 'Unexcuse Leave');
                    } else {
                      key = getKeyByValue(w.globals.labels, 'Tanpa Keterangan');
                    }
                    if (key) {
                      return w.globals.seriesTotals[key];
                    } else {
                      return 0;
                    }
                  }
                }
              }
            }
          }
        }
      }
    };
  },
  watch: {
    ['table.options']() {
      this.getData();
    },
    filter: {
      deep: true,
      handler() {
        this.getData();
      }
    },
    student: {
      deep: true,
      handler() {
        this.clearFilter();
        if (this.isAuthenticated) {
          this.$router.push({ name: 'ParentClassIndex' });
        }
      }
    },
    '$i18n.locale': {
      immediate: true,
      handler() {
        this.createChart();
        this.chartOptions.plotOptions.pie.donut.labels.total.label = this.$t('content.attendance_item.unexcuse_leave');
      }
    }
  },
  methods: {
    getDataClass() {
      if (!this.$route.params.classSectionId) {
        this.$store
          .dispatch('Class/fetchClassroomCourseName', { classId: this.$route.params.classId, courseId: this.$route.params.courseId })
          .then(res => {
            if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
              this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            } else {
              this.$store.dispatch('Class/fetchListLiteDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            }
          });
      } else {
        this.$store.dispatch('ClassSection/getListDetail', { classSectionId: this.$route.params.classSectionId }).then(res => {
          if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
            this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
              this.dataClass = resa;
              this.titleData = res.classroomName + ` ${res.numberClass}` + ` ( ${resa.yearPeriode} ) `;
            });
          }
        });
      }
    },
    getData() {
      const { courseId, classId } = this.$route.params;

      this.table.loading = true;
      this.$store
        .dispatch('Attendance/fetchList', {
          classId,
          courseId,
          classSectionId: this.$route.params.classSectionId ? this.$route.params.classSectionId : '',
          ...this.filter,
          ...this.table.options
        })
        .then(data => (this.listData = data))
        .finally(() => (this.table.loading = false));
    },
    clearFilter() {
      this.filter.attendanceDate = null;
      this.filter.attendanceTypeId = null;
    },
    getNameTypes(id) {
      return this.$t(this.itemTypes.find(i => i.value == id)?.text);
    },
    createChart() {
      const { courseId, classId } = this.$route.params;
      this.$store
        .dispatch('Attendance/fetchChart', {
          classId,
          courseId,
          classSectionId: this.$route.params.classSectionId ? this.$route.params.classSectionId : ''
        })
        .then(({ series, labels, length }) => {
          this.series = series;
          this.chartOptions = Object.assign({}, this.chartOptions, {
            labels: labels.map(s => `${this.getNameTypes(s)}`),
            // labels: labels.map((s, index) => `${series[index]} ${this.getNameTypes(s)}`),
            colors: labels.map(s => this.colors[s])
          });
          this.hideChart = length > 0;
        });
    }
  },
  created() {
    this.getDataClass();
    this.getData();
    this.$store.commit('table/RESET_PAGEABLE');
  }
};
</script>

<style lang="scss" scoped>
.border-item {
  border-bottom: 1px solid #dedede;
}
.text-dropdown {
  cursor: pointer;
  &-delete {
    color: red;
    cursor: pointer;
  }
}

.header-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 14px;
  line-height: 16px;
  width: 133px;
  text-align: left;
}

.body-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}

.section-header {
  border-radius: 4px 4px 0 0;

  &.active {
    background: #00bf63;
    .student-title {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
    }
  }

  &.disabled {
    background: #acacac;
    pointer-events: none;

    .student-title {
      color: #fff;
    }
  }
}
</style>
